import { useCallback, useEffect, useState } from 'react'
import { Button, Form, Input, Space, Table, TableProps } from 'antd'
import { SearchOutlined, UndoOutlined } from "@ant-design/icons"
import { useLoading } from '../../context/LoadingContext'
import { apiGetListSimInventory } from '../../api'
import { renderStatus } from '../quanlytopup'
import { toastError } from '../../utils/toast'
import moment from 'moment'

export default function SimExportHistory() {
    const [simInventory, setSimInventory] = useState<any>()
    const [search, setSearch] = useState<any>({})

    const { setIsLoading } = useLoading()
    const [formSearch] = Form.useForm()

    const columns: TableProps<any>['columns'] = [
        {
            key: 'order_id',
            title: 'Mã đơn hàng',
            dataIndex: 'order_id',
            render: order_id => (
                <span style={{ whiteSpace: 'nowrap' }}>
                    {order_id}
                </span>
            ),
        },
        {
            key: 'cpCode',
            title: 'Mã công ty',
            dataIndex: 'cpCode',
        },
        {
            key: 'description',
            title: 'Mô tả',
            dataIndex: 'description',
        },
        {
            key: 'created_at',
            title: 'Ngày bán',
            dataIndex: 'created_at',
            render: created_at => moment(created_at).format('DD/MM/YYYY HH:mm:ss'),
        },
        {
            key: 'status',
            title: 'Trạng thái',
            dataIndex: 'status',
            render: status => renderStatus(status)
        },
    ]

    const fetchData = useCallback(async () => {
        if (!search.serialSim) return
        if (search.serialSim?.length !== 19 || !/^\d+$/.test(search.serialSim)) {
            toastError('Serial Sim không hợp lệ')
            return
        }
        try {
            setIsLoading(true)
            const prefixSim = search.serialSim.slice(0, 14)
            const { data } = await apiGetListSimInventory({
                prefixSim,
                status: 'SUCCESS',
                type: 'INVENTORY',
            })
            const numberSim = Number(search.serialSim.slice(-5))
            const serialSim = data.simInventory.filter((item: any) => {
                const startNumber = Number(item.start_sim.slice(-5))
                const endNumber = Number(item.end_sim.slice(-5))
                return numberSim >= startNumber && numberSim <= endNumber
            })
            setSimInventory({ total: serialSim.length, simInventory: serialSim })
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }, [setIsLoading, search])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    const handleSearch = ({ serialSim }: any) => {
        if (serialSim) {
            setSearch({ serialSim })
        }
    }

    const handleClearSearch = () => {
        setSimInventory({})
        formSearch.resetFields()
        setSearch({})
    }

    return (
        <div>
            <Form form={formSearch} onFinish={handleSearch} id="searchForm" layout='horizontal' autoComplete='off'>
                <div style={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                    <Form.Item name='serialSim' label='Serial Sim'>
                        <Input />
                    </Form.Item>
                    <Space>
                        <Button type='primary' htmlType="submit" icon={<SearchOutlined />}>Tìm kiếm</Button>
                        <Button onClick={handleClearSearch} icon={<UndoOutlined />}></Button>
                    </Space>
                </div>
            </Form>
            <Table
                columns={columns}
                dataSource={simInventory?.simInventory}
                pagination={false}
            />
        </div>
    )
}
